var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[(_vm.isActive === null)?_c('Sort',{staticClass:"icon__sort",attrs:{"alt":_vm.alt}}):(_vm.isActive)?_c('SortDown',{staticClass:"icon__sort",attrs:{"alt":_vm.alt}}):_c('SortUp',{staticClass:"icon__sort",attrs:{"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }